import { render, staticRenderFns } from "./step-form.vue?vue&type=template&id=70265e66&scoped=true&"
import script from "./step-form.vue?vue&type=script&lang=js&"
export * from "./step-form.vue?vue&type=script&lang=js&"
import style0 from "./step-form.vue?vue&type=style&index=0&id=70265e66&lang=scss&scoped=true&"
import style1 from "./step-form.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70265e66",
  null
  
)

export default component.exports